import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// 1. Ant Design
import { Alert, Form, Input, Modal } from "antd";
// 2. External libraries
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import styles from "@/styles/CompanyLinks.module.less";
/** Предупреждение CCR-010 / D17: блокировка замораживает даты уже созданных заказов сотрудника. */
export const BLOCK_FREEZE_WARNING = "Заказы сотрудника останутся корпоративными и будут выполнены, но их дату нельзя будет перенести до снятия блокировки";
/** «Заблокировать» привязку (BR-LNK-12): подтверждение с предупреждением о заморозке дат и причиной. */
const CompanyLinkBlockModal = observer(({ store, link, onClose }) => {
    const [form] = Form.useForm();
    useEffect(() => {
        if (link)
            form.resetFields();
    }, [link]);
    if (!link)
        return null;
    const handleConfirm = async () => {
        const values = await form.validateFields().catch(() => null);
        if (!values)
            return;
        const { reason } = values;
        const blocked = await store.setBlocked(link.linkId, true, reason?.trim() || null);
        if (blocked)
            onClose();
    };
    return (_jsxs(Modal, { open: true, title: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u0438\u0432\u044F\u0437\u043A\u0443?", okText: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C", okButtonProps: { danger: true, loading: store.isSubmitting }, cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430", onOk: handleConfirm, onCancel: onClose, destroyOnHidden: true, children: [_jsx(Alert, { type: "warning", showIcon: true, className: styles.modalNotice, message: "\u041D\u043E\u0432\u044B\u0435 \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0435 \u0437\u0430\u043A\u0430\u0437\u044B \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430 \u0431\u0443\u0434\u0443\u0442 \u043E\u0442\u043A\u043B\u043E\u043D\u044F\u0442\u044C\u0441\u044F", description: BLOCK_FREEZE_WARNING }), _jsx(Form, { form: form, layout: "vertical", children: _jsx(Form.Item, { name: "reason", label: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)", children: _jsx(Input.TextArea, { autoSize: { minRows: 2, maxRows: 4 }, maxLength: 500, showCount: true }) }) })] }));
});
CompanyLinkBlockModal.displayName = "CompanyLinkBlockModal";
export default CompanyLinkBlockModal;
